export const levelCheck = {
  title: 'レベルチェック',
  subtitle: 'あなたの現在の言語レベルを確認しましょう',
  
  // Language Selection
  selectLanguage: '学習言語を選択',
  selectLanguagePlaceholder: '言語を選択してください',
  japanese: '日本語',
  korean: '한국어',
  english: 'English',
  
  // Email Input
  emailLabel: 'メールアドレス',
  emailPlaceholder: 'your.email@example.com',
  emailDescription: 'テスト結果をお送りします',
  
  // Buttons
  startTest: 'テストを開始',
  nextQuestion: '次へ',
  previousQuestion: '戻る',
  submitTest: 'テストを提出',
  
  // Test Progress
  question: '問題',
  of: '/',
  
  // Results
  resultsTitle: 'テスト結果',
  yourLevel: 'あなたのレベル',
  score: 'スコア',
  passed: '合格',
  failed: '不合格',
  passThreshold: '合格ライン: 85%以上',
  
  // Messages
  selectLanguageFirst: '言語を選択してください',
  enterEmail: 'メールアドレスを入力してください',
  testSubmitted: 'テストを提出しました。結果をメールでお送りします。',
  errorSubmitting: 'エラーが発生しました。もう一度お試しください。',

  // ── レベルチェックページ全体 (level-check/page.tsx) ──
  // バリデーション・アラート
  enterName: '名前を入力してください',
  invalidEmail: 'メールアドレスの形式が正しくありません',
  selectLearningLanguage: '学習中の言語を選択してください',
  saveFailed: '結果の保存に失敗しました。もう一度お試しください。',

  // 言語名（学習言語の表示）
  langEnglish: '英語',
  langJapanese: '日本語',
  langKorean: '韓国語',

  // イントロ画面
  pageTitle: '言語レベルチェック',
  pageSubtitle: 'レベルチェックを開始する前に、情報を入力してください',
  namePlaceholder: 'お名前',
  emailInputPlaceholder: 'メールアドレス',
  selectLearningLanguageLabel: '学習中の言語を選択してください',
  testStructure: 'テスト構成:',
  levelAJa: 'レベルA: 12問（語彙4問 + 能力8問）',
  levelAOther: 'レベルA: 8-10問（初級）',
  levelB1Ja: 'レベルB1: 12問（語彙4問 + 能力8問）',
  levelB1Other: 'レベルB1: 8-10問（中級）',
  levelB2Ja: 'レベルB2: 12問（語彙4問 + 能力8問）',
  levelB2Other: 'レベルB2: 8-10問（中上級）',
  levelCJa: 'レベルC: 12問（語彙4問 + 能力8問）',
  levelCOther: 'レベルC: 8-10問（上級）',
  scoringNote: '各レベルで85%以上のスコアで次のレベルに進めます',
  scoringNoteJa: '各レベルで85%以上のスコアで次のレベルに進めます。日本語版：語彙問題20点 + 能力問題80点 = 合計100点',
  startCheck: 'レベルチェックを開始',

  // 結果画面
  testComplete: 'テスト完了！',
  learningLanguageLabel: '学習言語: ',
  yourLevelLabel: 'あなたのレベル: ',
  levelValue: 'レベル {{level}}',
  thankYouBody: 'レベルチェックを完了していただき、ありがとうございます、{{name}}さん！結果を確認し、{{email}}に次のステップをご連絡いたします。',
  returnHome: 'ホームに戻る',

  // クイズ画面
  levelAssessment: '言語レベル評価',
  questionProgress: '問題 {{current}} / {{total}}',
  previous: '前へ',
  next: '次へ',
  submitting: '送信中...',
  submitLevel: 'レベルを送信'
};
